<template>
  <div>
    <van-tabs
      :title-active-color="'#36B374'"
      :title-inactive-color="'#333333'"
      :line-width="'46px'"
      :line-height="'2px'"
    >
      <van-tab title="项目详情">
        <div class="project_details">
          <div class="information">
            <div class="content">
              <p class="title">基本信息</p>
              <table>
                <tr>
                  <td class="name">项目名称：</td>
                  <td>{{project.projectName}}</td>
                </tr>
                <tr>
                  <td class="name">建设地点：</td>
                  <td>{{project.locationName}}</td>
                </tr>
                <tr>
                  <td class="name">项目类型：</td>
                  <td>{{project.projectTypeName}}</td>
                </tr>
                <tr>
                  <td class="name">项目主体单位：</td>
                  <td>{{project.projectEntity}}</td>
                </tr>
                <tr>
                  <td class="name">拟引进投资：</td>
                  <td>{{project.investorRequirement}}</td>
                </tr>
                <tr>
                  <td class="name">项目推出年份：</td>
                  <td>{{project.projectLaunchYear}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="information">
            <div class="content">
              <p class="title">计划投资</p>
              <table>
                <tr>
                  <td class="name">计划投资额：</td>
                  <td>{{project.investmentMoney || 0}}亿</td>
                </tr>
                <tr>
                  <td class="name">筹措方式：</td>
                  <td>
                    {{project.financingMode}}
                  </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="information">
            <div class="content">
              <p class="title">项目简介</p>
              <table>
                <tr>
                  <td class="name">项目概述：</td>
                  <td>{{project.projectOverview}}</td>
                </tr>
                <tr>
                  <td class="name">项目内容：</td>
                  <td>{{project.projectContent}}</td>
                </tr>
                <tr>
                  <td class="name">配套条件：</td>
                  <td>{{project.supportingCondition}}</td>
                </tr>
                <tr>
                  <td class="name">项目可享受的优惠政策：</td>
                  <td>{{project.preferentialPolicy}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="information">
            <div class="content">
              <p class="title">市场分析</p>
              <table>
                <tr>
                  <td class="name">市场预测：</td>
                  <td>{{project.marketPrediction}}</td>
                </tr>
                <tr>
                  <td class="name">项目盈利模式及初步效益分析：</td>
                  <td>{{project.benefitAnalysis}}</td>
                </tr>
                <tr>
                  <td class="name">项目风险分析：</td>
                  <td>{{project.riskAnalysis}}</td>
                </tr>
                <tr>
                  <td class="name">合作方式：</td>
                  <td>{{project.cooperationMode}}</td>
                </tr>
              </table>
            </div>
          </div>
          <div class="information">
            <div class="content">
              <p class="title">项目联系信息</p>
              <table class="table">
                <tr>
                  <td class="name">联系单位：</td>
                  <td>{{project.contractOrg}}</td>
                </tr>
                <tr>
                  <td class="name">联系人：</td>
                  <td>{{project.contractPerson}}</td>
                </tr>
                <tr>
                  <td class="name">联系电话：</td>
                  <td v-if="contractPhoneShow">{{ project.contractPhone }}</td>
                  <td v-else>{{ getPhone(project.contractPhone) }}<span class="view" @click="contractPhoneShow = true">查看</span> </td>
                </tr>
                <tr>
                  <td class="name">传真：</td>
                  <td>{{project.fax}}</td>
                </tr>
                <tr>
                  <td class="name">电子邮件：</td>
                  <td>{{project.email}}</td>
                </tr>
                <!-- <tr>
                  <td class="name">填报单位：</td>
                  <td>{{project.creatorOrgName}}</td>
                </tr> -->
                <tr>
                  <td class="name">填报人姓名：</td>
                  <td>{{project.creatorName}}</td>
                </tr>
                <tr>
                  <td class="name">填报人联系电话：</td>
                  <!-- <td>{{project.creatorPhone}}</td> -->
                   <td v-if="InformantPhoneShow">{{ project.creatorPhone }}</td>
                  <td v-else>{{ getPhone2(project.creatorPhone) }}<span class="view" @click="InformantPhoneShow = true">查看</span> </td>
                </tr>
              </table>
            </div>
          </div>
          <div class="information" v-if="project.photoPath.length || project.download.length">
            <div class="top">
              <img
                v-for="(item, index) in project.photoPath"
                :key="index"
                :src="item"
                alt=""
              />
            </div>
            <div>
              <div
                v-for="(item, index) in project.download"
                :key="index"
                @click="download(item)"
                class="download"
              >
                <img src="../../../assets/investment/download.png" alt="" />
                <div class="span">
                  <span>附件{{ index + 1 }}：{{ item.filename }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="项目进度">
        <div class="project_details progress">
          <div class="information">
            
            <div class="content" v-for="(item,index) in following" :key="index">
              <p class="title-progress" v-if="!item.investorId && !item.isKeep">{{item.companyName || '项目'}}{{item.progress == 2 ? "达成意向合作":""}}{{item.progress == 3 ? "达成签约":""}}{{item.progress == 4 ? "已落地":""}}{{item.progress == 5 ? "已完成":""}}{{item.progress == 6 ? "已暂缓":""}}{{item.progress == 7 ? "已退出":""}}{{item.progress == 8 ? "已重新启动":""}}</p>
              <p class="title-progress" v-if="!item.investorId && item.isKeep">项目保持为{{item.progressName}}</p>
              <p class="title-progress" v-if="item.investorId && !item.isKeep">{{ item.companyName }}{{ (item.progress == 2 || item.progress == 3) ? '达成' : '' }}{{ (item.progress == 4 || item.progress == 5 || item.progress == 6 || item.progress == 7 || item.progress == 8) ? '已' : '' }}{{item.progressName}}{{ item.progress == 2 ? '合作' : '' }}</p>
              <p class="title-progress" v-if="item.investorId && item.isKeep">{{ item.companyName }}保持为{{item.progressName}}</p>
              <table>
                <tr v-if="!item.investorId && !item.isKeep && item.progress == 3">
                  <td class="name">时间：</td>
                  <td>{{item.contractPlaceDate}}</td>
                </tr>
                <tr v-else>
                  <td class="name">时间：</td>
                  <td>{{item.createTime}}</td>
                </tr>
                
                <!-- <tr>
                  <td class="name">企业：</td>
                  <td>{{ item.companyName }}</td>
                </tr> -->
                <tr>
                  <td class="name">操作人：</td>
                  <td>{{item.creatorOrgName}}-{{item.creatorName}}</td>
                </tr>
                <tr v-if="item.investorId && !item.isKeep && item.progress == 3">
                  <td class="name">签约类型：</td>
                  <td>{{item.contractCategoryName}}</td>
                </tr>
                <tr v-if="item.progress == 3 && item.contractPlaceAmount">
                  <td v-if="item.areaCode == '3'" class="name">签约外资金额（美元）：</td>
                  <td v-else class="name">签约金额（亿元）：</td>
                  <td>{{item.contractPlaceAmount}}</td>
                </tr>
                <tr v-if="(item.investorId && item.isKeep && item.progress == 4) || (item.investorId && !item.isKeep && item.progress == 4)">
                  <td v-if="item.areaCode == '3'" class="name">到位外资金额（美元）：</td>
                  <td v-else class="name">到位金额（亿元）：</td>
                  <td>{{item.contractPlaceAmount}}</td>
                </tr>
                <tr v-if="(item.investorId && item.isKeep && item.progress == 4) || (item.investorId && !item.isKeep && item.progress == 4)">
                  <td v-if="item.areaCode == '3'" class="name">总计到位外资金额（美元）：</td>
                  <td v-else class="name">总计到位金额（亿元）：</td>
                  <td>{{item.placeAmountTotal}}</td>
                </tr>
                <tr v-if="item.investorId && item.isKeep && item.progress == 4">
                  <td class="name">投资方：</td>
                  <td>{{item.companyName}}</td>
                </tr>
                <tr v-if="!item.investorId && item.isKeep && item.companyName">
                  <td class="name">企业名称：</td>
                  <td>{{item.companyName}}</td>
                </tr>
                <tr>
                  <td class="name">进度描述：</td>
                  <td>{{item.progressDesc}}</td>
                </tr>
              </table>
            </div>
          </div>
          
        </div>
      </van-tab>
      <div class="foot" v-if="isSupervision !== 'supervision'">
          <button v-if="project.status == 2 || project.status == 3" @click="onDelete()">删除</button>
          <button class="reject" v-if="(getUserType == 1 || getUserType == 2) && project.status == 1"  @click="$router.push({path: '/investment/projectHandle',query:{id:project.id}})">审核驳回</button>
          <button  v-if="(getUserType == 1 || getUserType == 2) && project.status == 1" @click="adopt()">审核通过</button>
      </div>
    </van-tabs>
    <downIos :downUrl="downUrl" v-if="showDown" @cancelDown="cancelDown"></downIos>
  </div>
</template>

<script>
import { mapActions,mapGetters } from "vuex";
import common from '../../../utils/common.js';
import { Dialog,Notify } from 'vant';
import downIos from '../components/downIos'

export default {
  name: "activityDetails",
  components: { downIos },
  props: {},
  data() {
    return {
      project:{
        download:[],
        photoPath: []
      },
      following: [],
      contractPhoneShow: false, // 联系人电话显示
      InformantPhoneShow: false, // 填报人电话显示
      showDown: false,
      downUrl: ''
    };
  },
  computed: {
    ...mapGetters('investment', ['getUserType']),
    id () {
      return this.$route.query.id
    },
    isSupervision() {
      return localStorage.getItem('attractRole')
    }
  },
  watch: {},
  methods: {
    ...mapActions("investment", [
      "setInvestmentTitle",
      "getProjectDetail",
      'getAttractInvestmentId',
      'deleteAttractById',
      'postAttractVerify'
    ]),
    cancelDown(type){
                if(type=='success'){
                  this.showDown=false;
                  setTimeout(()=>{this.$Toast('复制成功')},1000)
                }else{
                  this.showDown=false;
                }
                
            },
    getPhone(value) {
      let phone = value + ''
      return phone.substr(0, 2) + '******' + phone.substr(phone.length - 2)
    },
    getPhone2(value) {
      let phone = value + ''
      return phone.substr(0, 2) + '******' + phone.substr(phone.length - 2)
    },
    download(item) {
      this.downUrl = item.link
      // common.download(value)
      var u = navigator.userAgent;
      const isAndroid = u.indexOf("Android") > -1 || u.indexOf("Adr") > -1; //android终端
      if (isAndroid) {
        window.location.href = item.link;
      } else {
        this.$dispatch("downIosUrl", item.link);
        this.showDown = true
      }
    },
    onDelete(){
      Dialog.confirm({
        title: '删除',
        message: '是否确认删除',
      }).then(() => {
        this.deleteAttractById({id: this.id}).then(res=>{
          Notify({ type: 'success', message: '操作成功' });
          this.$router.go(-1)
        })
      }).catch(() => {
        // on cancel
      });
    },
    adopt(){
      this.postAttractVerify({
        id: this.id,
        flag: 1
      }).then(res=>{
        this.refresh()
      })
    },
    refresh(){
      this.getProjectDetail({id: this.id}).then(res=>{
        if (res.photoPath) {
          if (res.photoPath.indexOf('◎') !== -1) {
            res.photoPath = res.photoPath.split("◎");
          } else if (res.photoPath.indexOf(',') !== -1) {
            res.photoPath = res.photoPath.split(",")
          } else {
            res.photoPath = [res.photoPath]
          }
        } else {
          res.photoPath = [];
        }
        res.download = [];
        if (res.filePath) {
          if (res.filePath.indexOf('◎') !== -1) {
            res.filePath = res.filePath.split("◎");
          } else if (res.filePath.indexOf(',') !== -1) {
            res.filePath = res.filePath.split(",")
          } else {
            res.filePath = [res.filePath]
          }
          res.filePath.forEach((element) => {
            res.download.push({
              link: element,
              filename: element.substring(element.lastIndexOf("&&") + 2),
            });
          });
        } else {
          res.filePath = [];
        }
        this.project = res
      })

      this.getAttractInvestmentId({
        attractInvestmentId: this.id
      }).then(res=>{
        res.forEach(element => {

          element.createTime = element.createTime ? element.createTime.replace(/T/g,' ').replace(/Z/g,''):''
          element.contractPlaceDate = element.contractPlaceDate ? element.contractPlaceDate.replace(/T/g,' ').replace(/Z/g,''):''

        });
        
        this.following = res
      })
    }
  },
  created() {
    this.setInvestmentTitle("项目详情");
    this.refresh()
  },
  mounted() {},
};
</script>

<style lang="less" scoped>
/deep/.van-tabs__line {
  background-color: #36b374;
}
/deep/.van-tabs__nav--line {
  .van-tab {
    flex: none;
    padding-left: 12px;
    padding-right: 12px;
  }
}
.project_details {
  min-height: 100%;
  font-family: PingFangSC-Regular;
  padding: 12px 12px 108px;
  background: #F5F6F9;

  .information {
    background: #ffffff;
    padding: 0 20px 0px;
    margin-bottom: 12px;
    border-radius: 3px;
    .top {
      padding: 16px 0 12px;
      border-bottom: 0.5px solid rgba(238, 238, 238, 1);
      img {
        height: 143px;
        margin-bottom: 16px;
      }
    }
    .download {
      font-size: 0;
      padding: 12px 0 3px;
      display: flex;
      justify-content: flex-start;
      align-items: center;
      img {
        display: inline;
        width: 10px;
        height: 12px;
        line-height: 16px;
        margin-right: 6px;
      }
      .span {
        span {
          color: #2283e6;
          font-size: 12px;
          line-height: 16px;
          display: inline-block;
          transform: scale(0.8333);
          transform-origin: left center;
        }
      }
    }
    .content {
      color: #333333;
      font-size: 12px;
      line-height: 17px;
      word-break:break-all;

      table {
        table-layout: fixed;
        max-width: 100%;
        word-wrap: break-word;
        text-overflow: ellipsis;
        td {
          padding-top: 12px;
          padding-right: 8px;
          vertical-align: top;
          white-space: normal;
          span {
            color: rgb(43, 130, 255);
            margin-left: 5px;
          }
        }
        .name {
          white-space: nowrap;
          margin-right: 8px;
        }
      }
      .title {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-weight: bold;
        padding: 12px 0;
        border-bottom: 1px solid #eee;
      }
      .title-progress {
        font-size: 16px;
        color: #333333;
        line-height: 22px;
        font-weight: bold;
        padding-top: 18px;
      }
    }
  }
  
}
.foot {
  position: fixed;
  bottom: 0;
  left: 0;
  bottom: 0;
  padding: 13px 6px 47px;
  background: #ffffff;
  width: 100%;
  display: flex;
  button {
    margin: 0 6px;
    flex-grow: 1;
    border: 0;
    background: #36b374;
    display: block;
    padding: 13px;
    line-height: 22px;
    font-size: 16px;
    color: #ffffff;
    border-radius: 3px;
  }
  .reject{
    color: #36B374;
    background: #fff;
    border: 1px solid #36B374;
  }
}
.progress {
  .content {
    padding-bottom: 18px;
    border-bottom: 1px solid #eee;
  }
  .content:last-child {
    border: none;
  }
}
.view {
  color: #36b374 !important;
}
</style>